
var toSpace = require('to-space-case')

/**
 * Export.
 */

module.exports = toSnakeCase

/**
 * Convert a `string` to snake case.
 *
 * @param {String} string
 * @return {String}
 */

function toSnakeCase(string) {
  return toSpace(string).replace(/\s/g, '_')
}



//////////////////
// WEBPACK FOOTER
// ./~/to-snake-case/index.js
// module id = 1438
// module chunks = 168707334958949